export enum ProcedureValidationErrorType {
  NON_UNIQUE_NAME,
  INVALID_NAME,
  DELETED_PARAMETER,
  INVALID_PARAMETER_RANGE,
  INVALID_SCHEMA_FOR_PARAMETER_TYPE,
  SETPOINT_NOT_IN_RANGE,
  UPSTREAM_MATERIAL_EDGE,
  MISSING_MATERIAL_OUTPUT_TYPE,
  ARCHIVED_SCHEMA,
  MISMATCHED_VALUE_TYPE,
  MISMATCH_MODELS_TYPE,
  NEGATIVE_AMOUNT,
  PROCEDURE_PRODUCT_LIMITS,
  NON_ENTITY_MATERIAL_INPUT_CONFIRMED_VIA_PLATE_MAP,
  UNCONTAINABLE_SCHEMA_ON_MATERIAL_INPUT_CONFIRMED_VIA_PLATE_MAP,
  DUPLICATE_TEST_DEFINITION,
  DUPLICATE_DILUTION_FACTOR,
  INVALID_DILUTION_FACTOR,
  DILUTION_PLAN_WITHOUT_TEST_DEFINITIONS,
}

export enum ProcedureValidationObjectType {
  PROCEDURE,
  METHOD,
  MATERIAL_INPUT,
  MATERIAL_OUTPUT,
  DATA_PARAMETER,
  EQUIPMENT,
  MATERIAL_EDGE,
  STEP,
  TEST_DEFINITION,
  DILUTION_PLAN,
}

export const VALIDATION_ERROR_WITH_NO_DISPLAYED_OBJECT = 'never';

export interface ProcedureValidationObject {
  // This value is the cid if the object in question has a cid
  id: string | typeof VALIDATION_ERROR_WITH_NO_DISPLAYED_OBJECT;
  objectType: ProcedureValidationObjectType;
}

export interface ProcedureValidationError {
  errorMessage: string;
  type: ProcedureValidationErrorType;
  primaryObject: ProcedureValidationObject;
  parentObjects: Array<ProcedureValidationObject>;
}

export interface ProcedureValidationErrorsFilterCriteria {
  errorTypes?: Array<ProcedureValidationErrorType>;
  primaryObjectType?: ProcedureValidationObjectType;
  primaryObjectId?: string;
  parentObjectType?: ProcedureValidationObjectType;
  parentObjectId?: string;
}
